/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/core'
import { FunctionComponent } from 'react'
import { COLOR_PALETTE } from '../GlobalStyle'

type DividerProps = {
    text?: string
    color?: string
    style?: SerializedStyles
}

const Divider: FunctionComponent<DividerProps> = ({ text, color = COLOR_PALETTE.grey_light, style }) => {
    return (
        <div
            css={css`
                height: 20px;
                position: relative;
                width: 100%;
                display: inline-flex;
                justify-content: center;
                margin-bottom: 13px; // plus height/2 => ~23px of visual margin
                ${style}
            `}
        >
            <div
                css={css`
                    position: absolute;
                    top: 11px;
                    width: 100%;
                    border-bottom: 1px solid ${color};
                `}
            />
            {text && (
                <span
                    css={css`
                        z-index: 0;
                        padding: 0 5px;
                        color: ${COLOR_PALETTE.grey};
                        background-color: ${COLOR_PALETTE.white};
                    `}
                >
                    {text}
                </span>
            )}
        </div>
    )
}

export { Divider }
